export const DATE_FORMAT = 'iiii, LLLL do';

export default {
  DATE_FORMAT,
};
